<template>
  <div class="player" ref="player_container">
    <div class="global_pointer" :class="['player_volume', mute?'':'unmuted']" @click="changeVolume"></div>
    <vue-aliplayer-v2
      v-if="playerReady"
      :source="playUrl"
      ref="VueAliplayerV2"
      :options="options"
      :cssLink="`https://g.alicdn.com/de/prismplayer/2.9.22/skins/default/aliplayer-min.css`"
      :scriptSrc="`https://fr-static.shopshops.top/20220712/aliplayer2922.3705b20da73cf62f.js`"
      @error="playError"
      @ready="readyHandle"
      @play="$emit('play')"/>
      <!--
        :cssLink="require('@/assets/css/aliplayer.css')"
      :scriptSrc="require('@/assets/js/aliplayer.js')"
        :cssLink="`http://localhost:3000/css/aliplayer.css`"
        :scriptSrc="`http://localhost:3000/js/aliplayer.js`"
        `https://fr-static.shopshops.top/static/css/aliplayer/2.8.2/aliplayer-min.css`
        :scriptSrc="`https://fr-static.shopshops.top/static/js/aliplayer/2.8.2/aliplayer-h5-min.js`" -->
  </div>
</template>

<script>
export default {
  props: {
    playUrl: {
      type: String,
      default: '',
    },
    playUrlStreamInfo: {
      type: Object,
      default: {
        source: null,
        streams: null,
      },
    },
    isLive: {
      type: [Boolean, String],
      default: true,
    },
    liveStatus: {
      type: Number,
      default: 1,
    },
    coverImg: {
      type: String,
      default: '',
    },
  },
  created() {
    this.init();
  },
  watch: {
    playUrl: {
      mmediate: true,
      handler(val) {
        console.error('val----watch', val);
        if (val) {
          const player = this.$refs.VueAliplayerV2;
          player.reloadPlayer();
        }
      },
    },
  },
  destroyed() {
    console.log('player destroyed');
  },
  data() {
    return {
      playerReady: false,
      mute: true,
      options: {
        isLive: this.isLive,
        autoplay: true,
        width: '100%',
        height: '100%',
        // videoWidth: '100%',
        // videoHeight: '100%',
        playsinline: true,
        x5_fullscreen: false,
        preload: true,
        x5_type: 'h5',
        x5_video_position: 'top',
        rePlay: true,
        useH5Prism: true,
        showBarTime: '3000',
        controlBarVisibility: 'always',
        skinLayout: [],
      },
      // timmer: null
    };
  },
  beforeDestroy() {
    // clearTimeout(this.timmer)
    // this.timmer = null
  },
  methods: {
    readyHandle() {
      const { player } = this.$refs.VueAliplayerV2;
      const vWidth = player.tag.videoWidth;
      const vHeight = player.tag.videoHeight;
      if (vWidth > vHeight) {
        // 横屏
        document.getElementsByTagName('video')[0].classList.remove('vertical');
      } else {
        // 竖屏
        document.getElementsByTagName('video')[0].classList.add('vertical');
      }
      player.mute();
      player.play();
      setTimeout(() => {
        this.$isLogin();
      }, 3000);
    },
    playError(e) {
      this.$aliSLS.send({ playerType: '播放失败', errorInfo: e && e.paramData });
    },

    init() {
      let skin = [{
        name: 'bigPlayButton',
        align: 'cc',
      },
      {
        name: 'H5Loading',
        align: 'cc',
      }];
      if (this.liveStatus === 4) {
        skin = [
          {name: "bigPlayButton", align: "cc"},
          {name: "H5Loading", align: "cc"},
          // {
          //   name: "controlBar",
          //   children: [
          //     { name: "progress", align: "tl" },
          //     { name: "playButton", align: "tl" },
          //     { name: "timeDisplay", align: "tl" }
          //   ]
          // },
          {
            name: "controlBar", 
            align: "blabs", x: 0, y: 0,
            children: [
              {name: "progress", align: "blabs", x: 0, y: 44},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name: "timeDisplay", align: "tl", x: 10, y: 7},
              // {name: "fullScreenButton", align: "tr", x: 10, y: 12},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name: "volume", align: "tr", x: 5, y: 10}
            ]
          }
        ]
      }
      this.options.skinLayout = skin;
      if (this.coverImg) {
        this.options.cover = this.coverImg;
      }
      this.playerReady = true;

      this.setTimer();
    },

    setTimer() {
      if (window.Aliplayer) {
        // 设置aliplayer日志上报
        return this.$aliPlayerSetlogCBK();
      }

      if (!this.setTimer.count) {
        this.setTimer.count = 1;
      }

      // 2分钟还没加载上，就报警，并且以后每5秒上传一次
      if (this.setTimer.count > 2 * 60) {
        this.$aliSLS.send({
          errorInfo: `来自ssVuePlayer.vue文件的错误消息： aliPlayer加载异常，未检测到window.Aliplayer对象。【已尝试加载${this.setTimer.count}秒。】`,
        });
      }

      this.setTimer.count++;

      setTimeout(() => {
        this.setTimer();
      }, 1000);

      // const timeId = setInterval(() => {
      //   let VueCom = this.$refs.VueAliplayerV2
      //   if (VueCom && VueCom.player) {
      // this.$refs.VueAliplayerV2.player.play()
      //     clearInterval(timeId)
      //   }
      // }, 1000);
      // this.$refs.VueAliplayerV2.player.play()
      // this.timmer = setTimeout(() => {
      //   this.$refs.VueAliplayerV2.player.play()
      // }, 5000);
    },
    changeVolume() {
      this.mute = !this.mute;
      const { player } = this.$refs.VueAliplayerV2;
      if (this.mute) {
        player.mute();
      } else {
        player.unMute();
      }
    },
  },
};
</script>

<style>
.prism-player .prism-controlbar{
  z-index: 20 !important;
}
.prism-player .prism-liveshift-progress .prism-progress-played, .prism-player .prism-progress .prism-progress-played{
  background-color: rgba(255,255,255, .7) !important;
}
.vertical {
  object-fit: cover !important;
}
.prism-player .prism-cover {
  z-index: auto !important;
}
.prism-player .prism-big-play-btn{
  z-index: 21 !important;
}
</style>
<style scoped lang="less" scoped>
.player_volume{
  position: absolute;
  top: 154px;
  right: 14px;
  width: 36px;
  height: 36px;
  z-index: 100;
  background-size: 22px auto;
  background-image: url('../../assets/imgs/room/muted.png');
  background-repeat: no-repeat;
  background-position: center center;
  &.unmuted{
    background-image: url('../../assets/imgs/room/unmuted.png');
    background-size: 22px auto;
  }
}
</style>
